import { FileOutlined } from '@ant-design/icons';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { type ISectionWidget, WidgetSectionType } from './ISectionWidget.ts';
import { renderSectionHtml } from './renderSectionHtml.ts';
import { SectionWidgetComponent } from './SectionWidgetComponent.tsx';
import {
  SectionWidgetConfigComponent,
  SectionWidgetConfigSchema,
} from './SectionWidgetConfigComponent.tsx';

declare module '@framework/engine/schema/widgets/Widget.ts' {
  export enum WidgetType {
    Section = 'section',
  }
}

export const isSectionWidgetType = (
  widget: IWidgetType<any>,
): widget is IWidgetType<ISectionWidget> => {
  return widget.type === WidgetSectionType;
};

export const SectionWidgetType: IWidgetType<ISectionWidget> = {
  type: WidgetSectionType,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Sezione',
  icon: <FileOutlined />,
  supportedSectionTypes: ['DOCUMENT'],
  hasValue: false,
  formComponent: SectionWidgetComponent,
  configComponent: SectionWidgetConfigComponent,
  configValidator: SectionWidgetConfigSchema,
  previewComponent: SectionWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
  renderHtml: renderSectionHtml,
};
